type LoadingIndicatorProps = {
	message: string;
};

export function LoadingIndicator({ message }: LoadingIndicatorProps) {
	return (
		<p className="pf-loading" role="status">
			<span className="pf-loading__spinner" aria-hidden="true" />
			{message}
		</p>
	);
}
